import {Component, Inject, OnInit} from '@angular/core';
import {MatDialog, MatDialogRef, MAT_DIALOG_DATA} from '@angular/material';

export interface DialogData {
  title: string;
  message: string;
  icon: {
    add: boolean
    name: string
  }
}

@Component({
  selector: 'app-accept-decline-dialog',
  templateUrl: './accept-decline-dialog.component.html',
  styleUrls: ['./accept-decline-dialog.component.css']
})
export class AcceptDeclineDialogComponent {

  constructor(
    public dialogRef: MatDialogRef<AcceptDeclineDialogComponent>,
    @Inject(MAT_DIALOG_DATA) public data: DialogData) {}
}
